// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class ClaimV1TypesProcedureTypesCodeProcedureTypesResponse {
    static getAttributeTypeMap() {
        return ClaimV1TypesProcedureTypesCodeProcedureTypesResponse.attributeTypeMap;
    }
}
ClaimV1TypesProcedureTypesCodeProcedureTypesResponse.discriminator = undefined;
ClaimV1TypesProcedureTypesCodeProcedureTypesResponse.additionalProperties = false;
ClaimV1TypesProcedureTypesCodeProcedureTypesResponse.attributeTypeMap = [
    {
        "name": "success",
        "baseName": "success",
        "type": "boolean"
    },
    {
        "name": "data",
        "baseName": "data",
        "type": ""
    },
    {
        "name": "messages",
        "baseName": "messages",
        "type": ""
    },
];
//# sourceMappingURL=claimV1TypesProcedureTypesCodeProcedureTypesResponse.js.map